import React, { memo } from 'react';
import { Outlet } from 'react-router-dom';
import ModernSidebar from '../components/Sidebar/ModernSidebar';
import CreditDepletedBanner from '../components/Credits/CreditDepletedBanner';
import { CreditsProvider } from '../contexts/CreditsContext';
import useSidebarSync from '../hooks/useSidebarSync';
import '../styles/sidebar.css';

const MainContent = memo(({ sidebarWidth }) => (
  <main
    className="main-content"
    style={{
      marginLeft: sidebarWidth,
      transition: 'margin-left 0.3s cubic-bezier(0.4, 0, 0.2, 1)'
    }}
  >
    <CreditDepletedBanner />
    <Outlet />
  </main>
));

MainContent.displayName = 'MainContent';

export default function MainLayout() {
  const sidebarWidth = useSidebarSync();

  return (
    <CreditsProvider>
      <div className="main-layout-container">
        <ModernSidebar />
        <MainContent sidebarWidth={sidebarWidth} />
      </div>
    </CreditsProvider>
  );
}
